import { createAsyncSliceWithDataAndQuery } from '../createAsyncSliceWithDataAndQuery';
import { getConversationAsync } from '../../API/conversations/getConversationAsync';
import { IConversationData } from '../../types/conversations/IConversation';

export const { slice: conversationSlice, asyncAction: loadConversationAction } = createAsyncSliceWithDataAndQuery(
  'conversationSlice',
  getConversationAsync,
  {} as IConversationData
);
